import React from "react";
import styled from "styled-components";
import { ChatMessage } from "@lifeat/shared/rooms/room-chat/RoomChatTypes";
import PinIcon from "@icons/PinIcon.svg";
import { FontSize } from "@themes/Fonts";
import { PublicUserInfoForRoom } from "../RoomChatTypes";
import MessageBubble from "./MessageBubble";

const PinnedMessageContainer = styled.div`
    width: 100%;
`;

const PinnedMessageIndicator = styled.div`
    display: flex;
    padding: 7px 10px 0 50px;
    gap: 5px;

    width: 100%;
    font-size: ${FontSize.small};
    color: ${(props) => props.theme.textColorSpecial};
`;

const StyledPinIcon = styled(PinIcon)`
    fill: ${(props) => props.theme.textColorSpecial};
`;

const PINNED_MESSAGE_LABEL = "pinned by host";

interface PinnedMessageProps {
    readonly messageId: string;
    readonly message: ChatMessage["message"];
    readonly authorInfo: PublicUserInfoForRoom | undefined;
    readonly timeStamp: ChatMessage["sentTimestamp"];
    readonly isInteractingBlocked: boolean;
}
export default function PinnedMessage(props: PinnedMessageProps) {
    return (
        <PinnedMessageContainer>
            <PinnedMessageIndicator>
                <StyledPinIcon />
                {PINNED_MESSAGE_LABEL}
            </PinnedMessageIndicator>
            <MessageBubble
                messageId={props.messageId}
                message={props.message}
                authorInfo={props.authorInfo}
                timeStamp={props.timeStamp}
                isInteractingBlocked={props.isInteractingBlocked}
            />
        </PinnedMessageContainer>
    );
}
